import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LoginComponent } from "./components/login/login.component";
import { ResetPasswordComponent } from "./components/reset-password/reset-password.component";

import { SsoAuthComponent } from "./components/sso-auth/sso-auth.component";

const routes: Routes = [
    // { path: '', redirectTo:'login' },
    { path: ':id/:otp', component:ResetPasswordComponent},
    { path: '', component: LoginComponent },
    { path: 'sso-auth', component: SsoAuthComponent },
   
];

@NgModule({
    imports: [ RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AuthRoutingModule {
}